import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'

const RESOURCE_NAME = 'tributo'
const ENDPOINT = '/cadastros/tributos'

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingTributoSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingTributoSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_TRIBUTO_SUCCESS = 'LOADING_TRIBUTO_SUCCESS'
export function loadingTributoSuccess(tributo) {
  return {
    type: LOADING_TRIBUTO_SUCCESS,
    tributo,
  }
}

export const DESTROYING_TRIBUTO_SUCCESS = 'DESTROYING_TRIBUTO_SUCCESS'
export function destroyingTributoSuccess(tributoId) {
  return {
    type: DESTROYING_TRIBUTO_SUCCESS,
    tributoId,
  }
}

export function fetchMultipleTributo() {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(ENDPOINT).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchTributo(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}`).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createTributo(tributo) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(ENDPOINT, 'POST', tributo).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateTributo(id, tributo) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}`, 'PUT', tributo).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyTributo(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(`${ENDPOINT}/${id}`, 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const tributo = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_TRIBUTO_SUCCESS: {
      const { tributo: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_TRIBUTO_SUCCESS:
      return state.delete(action.tributoId.toString())

    default:
      return state
  }
}

export default tributo
